<template>
  <div class="error-message">
    <img :src="imageSrc" alt="Error Image" width="400">
    <p class="error-text">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    errorMessage: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.error-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  font-size: 24px;
  text-align: center;
}

.error-text {
  margin-top: 10px;
}
</style>
